import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    toasts: [],
    modals: {},
    sidebarOpen: false,
  }),

  actions: {
    // Toast notifications
    showToast({ message, type = 'info', duration = 3000 }) {
      const id = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      
      this.toasts.push({
        id,
        message,
        type, // 'success', 'error', 'warning', 'info'
        duration,
      });

      // Auto-remove after duration
      if (duration > 0) {
        setTimeout(() => {
          this.removeToast(id);
        }, duration);
      }

      return id;
    },

    removeToast(id) {
      const index = this.toasts.findIndex(t => t.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    },

    // Modal management
    openModal(name, data = {}) {
      this.modals[name] = {
        open: true,
        data,
      };
    },

    closeModal(name) {
      if (this.modals[name]) {
        this.modals[name].open = false;
      }
    },

    // Sidebar toggle
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },

    closeSidebar() {
      this.sidebarOpen = false;
    },
  },
});
